import get from 'lodash.get';
import {
    LOCATION_US_CODE,
    LOCATION_US_CITY_REGEXP,
    LOCATION_US_REGEXP,
    ELIGIBLE_CATEGORIES_L2,
} from './sbRespTradeOnApprovalPromoConstants';
import {
    getCategories,
    getCategory,
    getCategoryUrlLabel,
    CATEGORY_LEVEL_2,
} from '../../../utils/categoryHelpers';

function isUSCity(code) {
    return new RegExp(LOCATION_US_CITY_REGEXP).test(code);
}

export function isUSLocation(code) {
    return new RegExp(LOCATION_US_REGEXP).test(code);
}

export function getUSLocations({ locations, showOnlyCities = false }) {
    const checkFn = showOnlyCities ? isUSCity : isUSLocation;
    return locations.reduce((acc, location) => {
        const code = get(location, 'code');
        if (checkFn(code)) {
            acc.push(location);
        }
        return acc;
    }, []);
}

export function getUSCities({ locations }) {
    return getUSLocations({ locations, showOnlyCities: true });
}

export function getUSLocation({ locations }) {
    return locations.find(l => l.code === LOCATION_US_CODE);
}

export function mapLocationToOption(location) {
    return {
        label: location.name,
        value: location.label,
    };
}

export function insertItemAt(arr, item, index) {
    return [...arr.slice(0, index), item, ...arr.slice(index)];
}

function isUSLocationFilterApplied(filters) {
    const locationFilter = filters.find(f => f.name === 'location');
    const locationCode = get(locationFilter, 'values.0.code') || '';
    return isUSLocation(locationCode);
}

export function showTradeOnApprovalBanner({ appliedFilters }) {
    const categories = getCategories(appliedFilters);
    const categoryL2 = getCategory(categories, CATEGORY_LEVEL_2);
    const categoryL2UrlLabel = getCategoryUrlLabel(categoryL2);

    const isEligibleL2 = ELIGIBLE_CATEGORIES_L2.includes(categoryL2UrlLabel);
    const isUSLoc = isUSLocationFilterApplied(appliedFilters);

    return isEligibleL2 && isUSLoc;
}
